module.exports = __webpack_public_path__ + "img/threads.e8585f55.svg";